<template>
  <div class="meanbox">
    <van-cell-group>
  <van-cell title="头像" center style="ling-height:60px;" >
    <template #right-icon>
        <div class="portraitimg">
          <img :src="userInfo.headImg" alt="头像">
        </div>
    </template>
  </van-cell>
  <van-cell title="手机号" :value="userInfo.mobilePhone" />
  <van-cell title="修改登录手机号" is-link :value="userInfo.mobilePhone"  @click="toedit"/>
  <van-cell title="隐私声明" @click="goPrivacy" is-link />
  <van-cell title="用户协议" @click="goRegLicense" is-link />
</van-cell-group>
<!--
     <div style="margin-top: 40px;">
        <van-button round
                    block
                    type="info"
                    class="butout"
                    native-type="submit">退出登录</van-button>
      </div>
-->

  </div>
</template>
<script>
import { mapState } from 'vuex'
export default {
  computed: {
    ...mapState(['userInfo']),
  },
  mounted() {
    console.log(this.userInfo,'111111111111111111====')
  },
  methods:{
    goRegLicense() {
      this.$router.push({ path: '/register-protocol' })
    },
    goPrivacy() {
      this.$router.push({ path: '/privacy-statement' })
    },
    toedit(){
      this.$router.push({ path: '/edit-phone' })
    }
  }
}
</script>
<style scoped lang="scss">
.meanbox{
  height: 100%;
}
.portraitimg{
  width: 60px;
  height: 60px;
    img{
      width: 100%;
      height: 100%;
      border-radius: 50%;
    }
  }
.butout{
  width: 70%;
  margin: 0 auto;
  height: px2rem(120);
  background:#fff;
  border: #fcfcff;
  border-radius:  px2rem(60);
  color: #DB0003;
}
</style>